'use client';

import { useEffect } from 'react';
import type { FormState } from 'react-hook-form';

// hook to trigger a callback when the form has errors
// based on an example from react-hook-form community:
// https://github.com/react-hook-form/react-hook-form/issues/1574
export const useFormErrorTrigger = (
    formState: FormState<unknown & {}>,
    callback: () => void,
) => {
    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
    useEffect(() => {
        if (Object.keys(formState.errors).length !== 0) {
            callback();
        }
    }, [JSON.stringify(formState.errors), formState.submitCount]);
};
